<template>
<section class="rent-report cross-cities n-mb-8">
    <h2 class="rent-report__period-title n-mb-2">Показатели рынка аренды жилья в разрезе городов</h2>
    <p class="rent-report__date n-mb-4">{{ city.subtitle }}</p>
    <div class="rent-report__table n-mb-3" v-if="!isMobile">
        <div class="rent-report__table--row__head">
            <div class="rent-report__table--row-cell__head"></div>
            <div class="rent-report__table--row-cell__head" :class="item?.hint ? 'rent-report__table--tooltip' : ''"
                v-for="(item, idx) in city.th">
                <template v-if="item?.hint">
                    <ul>
                        <li>{{ idx }}</li>
                        <li>
                            <tooltip-wrapper class="rent-report__table--tooltip-desk-icon" arrow="arrow"
                                placement="bottom-start">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
                                        fill="#6D6D6D" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M6.83333 7.5C6.83333 7.13181 7.13181 6.83333 7.5 6.83333H8C8.36819 6.83333 8.66667 7.13181 8.66667 7.5V10.3543C8.9542 10.4283 9.16667 10.6894 9.16667 11C9.16667 11.3682 8.86819 11.6667 8.5 11.6667H8C7.63181 11.6667 7.33333 11.3682 7.33333 11V8.14566C7.0458 8.07166 6.83333 7.81064 6.83333 7.5Z"
                                        fill="#6D6D6D" />
                                    <path
                                        d="M7.875 6C8.28921 6 8.625 5.66421 8.625 5.25C8.625 4.83579 8.28921 4.5 7.875 4.5C7.46079 4.5 7.125 4.83579 7.125 5.25C7.125 5.66421 7.46079 6 7.875 6Z"
                                        fill="#6D6D6D" />
                                </svg>
                                <template #content>
                                    <div class="popper-subtitle">{{ item?.hint }}</div>
                                </template>
                            </tooltip-wrapper>
                        </li>
                    </ul>
                </template>
                <template v-else>
                    {{ idx }}
                </template>
            </div>
        </div>
        <div class="rent-report__table--row__subhead">
            <div class="rent-report__table--row-cell__subhead"></div>
            <div class="rent-report__table--row-cell__subhead1" v-for="(item, idx) in city.th">
                <div class="rent-report__table--row-cell__subhead" v-for="itm in item.cols"
                    v-html="itm.replace(' ', '<br>')"></div>
            </div>
        </div>
        <template class="rent-report__table" v-for="(item, index) in cityList.items" :key="item.name">
            <template v-if="item.cities !== undefined">
                <table-row :city="item" @innerList="setShowInnerList"></table-row>
                <div
                    :class="isShowInnerList ? 'rent-report__table--row- rent-report__table--row-active' : 'rent-report__table--row-'">
                    <div>
                        <div class="rent-report__table--inner-list" v-for="item in item.cities" :key="item">
                            <table-row :city="item" :idx="index"></table-row>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <table-row :city="item" :idx="index"></table-row>
            </template>
        </template>
    </div>
    <div v-else class="rent-report__table-mob n-mb-3">
        <template class="" v-for="(city, index) in cityList.items" :key="city.name">
            <div class="rent-report__table-mob__row" :class="{ active: index === currentIndex }">
                <div class="rent-report__table-mob__title" @click="showSubRow(city, index)">
                    <div class="rent-report__table-mob__wrapper">
                        <span>{{ city.name }}</span>
                        <span>{{ city.hint }}</span>
                    </div>
                    <div class="rent-report__table-mob__icon"></div>
                </div>
                <div class="rent-report__table-mob__wrapper">
                    <div class="rent-report__table-mob__body">
                        <template v-for="(th, index) of cityList.th">
                            <div class="rent-report__table-mob--title">
                                {{ index }}
                                <template v-if="th?.hint">
                                    <tooltip-wrapper class="rent-report__table--tooltip-icon" arrow="arrow"
                                        placement="bottom-start">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
                                                fill="#6D6D6D" />
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M6.83333 7.5C6.83333 7.13181 7.13181 6.83333 7.5 6.83333H8C8.36819 6.83333 8.66667 7.13181 8.66667 7.5V10.3543C8.9542 10.4283 9.16667 10.6894 9.16667 11C9.16667 11.3682 8.86819 11.6667 8.5 11.6667H8C7.63181 11.6667 7.33333 11.3682 7.33333 11V8.14566C7.0458 8.07166 6.83333 7.81064 6.83333 7.5Z"
                                                fill="#6D6D6D" />
                                            <path
                                                d="M7.875 6C8.28921 6 8.625 5.66421 8.625 5.25C8.625 4.83579 8.28921 4.5 7.875 4.5C7.46079 4.5 7.125 4.83579 7.125 5.25C7.125 5.66421 7.46079 6 7.875 6Z"
                                                fill="#6D6D6D" />
                                        </svg>
                                        <template #content>
                                            <div class="popper-subtitle">{{ th?.hint }}</div>
                                        </template>
                                    </tooltip-wrapper>
                                </template>
                            </div>
                            <div class="rent-report__table-mob--subtitle">
                                <span class="subtitle" v-for="(cols, indexCols) of cityList.th[index].cols"
                                    v-html="cols"> </span>
                            </div>
                            <div class="rent-report__table-mob--subtitle">
                                <span class="value"
                                    :class="isPosi(formatNumber(Object.values(city).find(el => el[index])[index], index), index)"
                                    v-for="(th, index) of cityList.th[index].cols">
                                    {{ formatNumber(Object.values(city).find(el => el[index])[index], index) }}
                                </span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
    </div>

    <div class="rent-report__table--source n-mb-3" v-html="city.sources"></div>

    <div class="rent-report__download">
        <a class="rent-report__btn rent-report__btn--primary rent-report__btn--icon-left" :href="link.src"
            :title="link.title" :download="link.download">
            <svg class="rent-report__btn-svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 1.5C12.5523 1.5 13 1.94772 13 2.5L13 12.1771L15.8271 9.3508C16.2177 8.96033 16.8508 8.96041 17.2413 9.35099C17.6318 9.74157 17.6317 10.3747 17.2411 10.7652L12.707 15.2981C12.3165 15.6885 11.6835 15.6885 11.293 15.2981L6.75889 10.7652C6.36832 10.3747 6.36824 9.74157 6.75871 9.35099C7.14918 8.96041 7.78235 8.96033 8.17292 9.3508L11 12.1771L11 2.5C11 1.94772 11.4477 1.5 12 1.5ZM3 15C3.55228 15 4 15.4477 4 16V21L20 21L20 16C20 15.4477 20.4477 15 21 15C21.5523 15 22 15.4477 22 16L22 21.25C22 21.7436 21.7853 22.1974 21.4361 22.5175C21.0898 22.8349 20.6373 23 20.1818 23L3.81818 23C3.36269 23 2.91023 22.8349 2.56392 22.5175C2.21469 22.1974 2 21.7436 2 21.25L2 16C2 15.4477 2.44772 15 3 15Z"
                    fill="white" />
            </svg>
            <span class="rent-report__btn-txt"> Скачать весь отчет </span>
        </a>
    </div>
</section>
</template>

<script>
import TooltipWrapper from './TooltipWrapper';
import TableRow from './TableRow';
import { throttle } from 'throttle-debounce';
export default {
    name: 'MarketIndicator',
    components: { TooltipWrapper, TableRow },
    mixins: [],
    props: {
        city: {
            type: Object
        },
        link: {
            type: Object
        }
    },
    data() {
        return {
            tableHeader: [],
            windowWidth: null,
            currentIndex: null,
            isShowInnerList: false
        };
    },
    created() {
        this.setWindowWidth();
        window.addEventListener('resize', throttle(300, this.setWindowWidth));
    },
    mounted() {
        this.tableHeader = this.city.th;
    },
    computed: {
        isMobile() {
            return this.windowWidth <= 650;
        },
        cityList() {
            return this.city;
        },
    },
    methods: {
        setWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },

        setShowInnerList(val) {
            this.isShowInnerList = val;
        },

        formatNumber(val, index = null) {
            if (index === 'days_quarter' || index === 'days_year') {
                let num = Number(val);
                if (num > 0) {
                    num = '+' + num;
                    return num;
                } else return val;
            } else if (index === 'th_pieces' || index === 'days' || index === 'rub') {
                return val;
            } else {
                let num = Number(val);
                if (num > 0) {
                    num = '+' + num;
                }
                return num + '%';
            }
        },

        isPosi(val, index = null) {
            if (index === 'th_pieces' || index === 'days' || index === 'rub') {
                return;

            } else {
                let regExpPlus = /[+]/g;
                let regExpMinus = /[-]/g;
                let matchesPlus = val.match(regExpPlus);
                let matchesMinus = val.match(regExpMinus);
                if (matchesPlus && matchesPlus.length > 0 || Number(val) > 0) {
                    return 'plus';
                } else if (matchesMinus && matchesMinus.length > 0) {
                    return 'minus';
                } else if (val.replace('%', '') === '0') {
                    return 'zero';
                }
            }
        },

        showSubRow(item, index) {
            this.currentIndex === index ? (this.currentIndex = null) : (this.currentIndex = index);
        }
    }
};
</script>
